import React from "react";

import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { CSVLink } from "react-csv";
import { getFormattedDateDDMMYYYY } from "../../../../utilities/dateFunctions/formatdate";
import { formatINRCurrency } from "../../../../utilities/currency/currency";

export default function LoanOTSOutstandingLedgerList({
  loanOTSOutstandingLedgerList,
  ref,
}) {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  let currentDate = `${day}-${month}-${year}`;

  let csvData = loanOTSOutstandingLedgerList.map((data) => {
    return {
      "Loanee Name": data?.applicantname,
      "Loan Id": data?.loanee_id,
      "Loan Number": data?.loan_number,
      "Disbursement Amount": data?.di_amount,
      "Repayment Amount": data?.rp_amount,
      "Principal Outstanding Amount": data?.principle_outstanding_amount,
      "Interest Due Amount": data?.interest_due_amount,
      "Waiver Amount": data?.waiveramount,
      "Interest on Interest Due": data?.ioi_due,
      "Penal Interest Due": data?.penal_due,
      "Principal Repay": data?.principal_repay,
      "Loan Amount": data?.loan_amount,
      "Loan Disbursement Date": data?.loan_first_disbursment_date,
      "Loan Interest Rate": data?.loan_int_rate,
    };
  });

  return (
    <>
      <TableWrapper>
        <thead
          className="bg-slate-200 sticky text-sm top-0 pt-3 leading-5"
          ref={ref}
        >
          <tr>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Loanee Id
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Applicant Name
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Relative Name
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Category
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Gender
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Scheme Name
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              District
            </th>

            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Disbursement Amount
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Principle Outstanding
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              IOI Due
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Penal Due
            </th>

            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Waiver Amount
            </th>
            <th
              scope="col"
              className="px-6 py-2 text-left font-medium text-slate-900  tracking-wider"
            >
              Paid Amount
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100 text-slate-600 text-xs">
          {loanOTSOutstandingLedgerList?.length > 0 ? (
            loanOTSOutstandingLedgerList?.map((sanctionList, index) => (
              <tr
                key={index}
                className={index % 2 === 1 ? "bg-slate-100" : null}
              >
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.loanee_id}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.applicantname}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.applicantrelativename}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.categoryname}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.applicantgender}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.schemename || "NA"}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {sanctionList?.districtname}
                </td>

                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(sanctionList?.di_amount || 0)}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(
                    sanctionList?.principle_outstanding_amount || 0
                  )}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(sanctionList?.ioi_due || 0)}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(sanctionList?.penal_due || 0)}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(sanctionList?.waiveramount || 0)}
                </td>
                <td className="px-6 py-2 whitespace-nowrap">
                  {formatINRCurrency(sanctionList?.rp_amount || 0)}
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={8} className="p-4 text-center">
              No Record Found
            </td>
          )}
        </tbody>
      </TableWrapper>

      <div className="mt-10">
        <CSVLink
          className="bg-[#001727] hover:bg-[#001D31] text-white px-6 py-2"
          // data={loanOTSOutstandingLedgerList}
          data={csvData}
          target="_blank"
          filename={`SABCCO-LoanOTSOutstandingLedgers-Reports/${currentDate}.csv`}
        >
          Export CSV
        </CSVLink>
      </div>
    </>
  );
}
